export const defaultFormImages = [
  "personal/form-images/webp/form-pic-1",
  "personal/form-images/webp/form-pic-2",
  "personal/form-images/webp/form-pic-3",
  "personal/form-images/webp/form-pic-4",
  "personal/form-images/webp/form-pic-5",
  "personal/form-images/webp/form-pic-6",
  "personal/form-images/webp/form-pic-7",
  "personal/form-images/webp/form-pic-8",
  "personal/form-images/webp/form-pic-9",
  "personal/form-images/webp/form-pic-10",
  "personal/form-images/webp/form-pic-11",
  "personal/form-images/webp/form-pic-12",
  "personal/form-images/webp/form-pic-13",
  "personal/form-images/webp/form-pic-14",
  "personal/form-images/webp/form-pic-15",
  "personal/form-images/webp/form-pic-16",
  "personal/form-images/webp/form-pic-17",
  "personal/form-images/webp/form-pic-18",
  "personal/form-images/webp/form-pic-19",
  "personal/form-images/webp/form-pic-1",
  "personal/form-images/webp/form-pic-2",
  "personal/form-images/webp/form-pic-3",
  "personal/form-images/webp/form-pic-4",
  "personal/form-images/webp/form-pic-5",
  "personal/form-images/webp/form-pic-6",
  "personal/form-images/webp/form-pic-7",
  "personal/form-images/webp/form-pic-8",
  "personal/form-images/webp/form-pic-9",
  "personal/form-images/webp/form-pic-10",
  "personal/form-images/webp/form-pic-11",
  "personal/form-images/webp/form-pic-12",
  "personal/form-images/webp/form-pic-13",
  "personal/form-images/webp/form-pic-14",
  "personal/form-images/webp/form-pic-15",
  "personal/form-images/webp/form-pic-16",
  "personal/form-images/webp/form-pic-17",
  "personal/form-images/webp/form-pic-18",
  "personal/form-images/webp/form-pic-19",
];

export const defaultBackgrounds = [
  "personal/personal-backgrounds/webp/bg-1",
  "personal/personal-backgrounds/webp/bg-2",
  "personal/personal-backgrounds/webp/bg-3",
  //"personal/personal-backgrounds/webp/bg-4",
  "personal/personal-backgrounds/webp/bg-5",
  "personal/personal-backgrounds/webp/bg-6",
  "personal/personal-backgrounds/webp/bg-7",
  "personal/personal-backgrounds/webp/bg-8",
  "personal/personal-backgrounds/webp/bg-9",
  "personal/personal-backgrounds/webp/bg-10",
  "personal/personal-backgrounds/webp/bg-11",
  "personal/personal-backgrounds/webp/bg-12",
  // "personal/personal-backgrounds/webp/bg-13",
];

export const embedColorCode = "#17CB49";

export const orderedSizeLimitListJumboForms = [
  { id: 9, size: "10MB" }, //0
  { id: 10, size: "25MB" }, //1
  { id: 1, size: "50MB" }, //2
  { id: 11, size: "100MB" }, //3
  { id: 2, size: "200MB" }, //4
  { id: 3, size: "500MB" }, //5
  { id: 4, size: "750MB" }, //6
  { id: 5, size: "1GB" }, //7
  { id: 6, size: "1.5GB" }, //8
  { id: 7, size: "2GB" }, //9
  { id: 12, size: "4GB" }, //10
  { id: 13, size: "5GB" }, //11
  { id: 16, size: "8GB" }, //12
  { id: 17, size: "10GB" }, //13
  { id: 18, size: "20GB" }, //14
  { id: 19, size: "50GB" }, //15
  { id: 20, size: "500GB" }, //16
];

export const freeUsersSizeLimitListJumboForms = 9; //2GB
export const subscribersSizeLimitListJumboForms = 11; //5GB
export const businessSizeLimitListJumboForms = 14; //20GB
export const premiumSizeLimitListJumboForms = 16; //500GB
